import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"

export const Gradient = styled.div`
  ${({theme}) => css`
    border-radius: ${theme.border.radius.large} ${theme.border.radius.large} 0 0;
    background-image: linear-gradient(to left, ${theme.colors.primary1}, ${theme.colors.primary2});
    padding: ${theme.spacing.oneAndHalf};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.three} ${theme.spacing.five};
    `}
  `}
`

export const BannerImage = styled.img`
  max-width: 100%;
  height: auto;
`

export const ResponsiveMargin = styled.div`
  ${({theme}) => css`
    margin: ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: ${theme.spacing.eight};
    `}
  `}
`

export const BannerLayout = styled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.desktop`
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
    `}
  `}
`

export const ResponsiveCard = styled(Card)`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.grey03};
    box-shadow: ${theme.shadows.low};
    background-color: ${theme.colors.utility.white};
  `}
`

export const MobileCta = styled(Button)`
  ${({theme}) => css`
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 10px;
    ${theme.mediaQueries.minWidthMedia.tablet`
      display: none;
    `}
  `}
`

export const BenefitHeaderContainer = styled(Flex)`
  ${({theme}) => css`
    flex-direction: row;
    padding: 2px;
    gap: 2px;
    align-items: center;
    margin: ${theme.spacing.six} 0 ${theme.spacing.three} 0;
    justify-content: space-between;
    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 100%;
      gap: 2px;
    `}
  `}
`

export const BenefitHeaderLogo = styled.img`
  height: 28px;
  width: 98px;
`

export const BenefitInfoContainer = styled(Flex)`
  ${({theme}) => css`
    border-radius: ${theme.border.radius.extraLarge};
    flex-direction: column;
    border: none;
    box-shadow: none;
    width: 100%;
    margin-bottom: ${theme.spacing.six};
    gap: ${theme.spacing.oneAndHalf};
    ${theme.mediaQueries.minWidthMedia.tablet`
      flex-direction: row;
      width: 100%;
      border: 1px solid ${theme.colors.greys.grey20};
      box-shadow: ${theme.shadows.low};
      gap: 0;
    `}
  `}
`

export const BenefitInfoContentCard = styled(Flex)`
  ${({theme}) => css`
    flex: 1;
    flex-direction: column;
    justify-content: center;
    gap: ${theme.spacing.oneAndHalf};
    padding: 0;
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.seven} ${theme.spacing.six};
    `}
  `}
`

export const BenefitInfoLogo = styled.img`
  height: auto;
  width: 100%;
`

export const BenefitImage = styled.img<{imagePosition: string}>`
  ${({imagePosition, theme}) => css`
    width: 100%;
    height: auto;
    object-fit: cover;
    ${imagePosition === "left"
      ? `border-top-left-radius: ${theme.border.radius.extraLarge};
         border-bottom-left-radius: ${theme.border.radius.extraLarge};`
      : `border-top-right-radius: ${theme.border.radius.extraLarge};
         border-bottom-right-radius: ${theme.border.radius.extraLarge};`}

    ${theme.mediaQueries.maxWidthMedia.tablet`
      border-radius: ${theme.border.radius.extraLarge};
    `}
  `}
`

export const BenefitTilesContainer = styled.div`
  ${({theme}) => css`
    background-color: #f8f9fa;
    padding: ${theme.spacing.two};
    border-radius: ${theme.spacing.oneAndHalf};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  `}
`

export const BenefitTilesCard = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    gap: 1.5rem;
    padding: ${theme.spacing.two} 0;

    &:not(:last-child) {
      border-bottom: 1px solid #e5e7eb;
    }
  `}
`

export const BenefitIconContainer = styled.div<{bgColor?: string}>`
  ${({theme, bgColor}) => css`
    width: 4rem;
    height: 4rem;
    border-radius: ${theme.border.radius.extraLarge};
    background-color: ${bgColor};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  `}
`

export const StepWrapper = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.grey03};
    margin-bottom: ${theme.spacing.six};
  `}
`

export const StepGridContainer = styled.div<{stepsPerRow?: number}>`
  ${({theme, stepsPerRow = 3}) => css`
    display: grid;
    gap: ${theme.spacing.two};
    grid-template-columns: none;
    ${theme.mediaQueries.minWidthMedia.tablet`
    width: 100%;
    grid-template-columns: repeat(${stepsPerRow}, minmax(0, 1fr));
  `}
  `}
`

export const StepContent = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.three};
    padding: ${theme.spacing.six} 0 ${theme.spacing.six} 0;
  `}
`

export const BenefitFaqContainer = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.three};
    border: 1px solid ${theme.colors.greys.disabled};
    border-radius: ${theme.spacing.oneAndHalf};
    margin: ${theme.spacing.six} 0 ${theme.spacing.nine} 0;
    ${theme.mediaQueries.minWidthMedia.tablet`
      width: 100%;
      gap: 2px;
    `}
  `}
`
